export const CLR_ACTIVE = 'success';
export const CLR_SECONDARY = 'secondary';
export const CLR_INACTIVE = 'danger';
export const CLR_PRELIMS = 'yellow';
export const CLR_WARNING = 'warning';

export const BG_SUCCESS = 'success';
export const BG_DANGER = 'danger';
export const BG_WARNING = 'warning';
export const BG_INFO = 'info';
export const BG_PRIMARY = 'primary';
export const BG_SECONDARY = 'secondary';
export const BG_DARK = 'dark';

export const CLR_TEXT_ACTIVE = 'text-success';
export const CLR_TEXT_INACTIVE = 'text-danger';
export const CLR_TEXT_PRELIMS = 'text-yellow';
export const CLR_TEXT_WARNING = 'text-warning';
